<template>
  <section class="serviceIntroduction">
    <div class="contentItem" v-for="(item, index) in serviceIntroduction" :key="index" v-show='item.type == 10'>
      <h3 class="f28 bold">{{item.blockName}}</h3>
      <div  v-if='item.blockPic'>
        <img  style='width:100%' v-for='(data,dataIndex) in JSON.parse(item.blockPic)' :src='formatImgUrl(data,1400,1400)'>
      </div>
      
      <div v-if='item.blockContent' v-html="item.blockContent" class='blockContent'></div>
    </div>
    <div class="line" ref='morer' id='morer'></div>
    <van-collapse v-model="activeNames" class='pdb'>
      <van-collapse-item v-for="(item,index) in collapseArr" :key="index" :name="index" >
        <div slot="title">
          {{item.title}}
        </div>
        <img :src="'/images/home/'+item.imgUrl+'.png'" align="middle">
      </van-collapse-item>
    </van-collapse>
  </section>
</template>

<script>
  // const img = 'https://img.yzcdn.cn/public_files/2017/09/05/3bd347e44233a868c99cf0fe560232be.jpg'
  import zhugeObj from '@/assets/js/track'
  export default {
    name: 'serviceIntroduction',
    props: {
      serviceIntroduction: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        activeNames: [0],
        collapseArr: [
          { title: '服务流程', imgUrl: 'service_detail_pic01' },
          { title: '包拯承诺', imgUrl: 'service_detail_pic02' },
          { title: '服务特色', imgUrl: 'service_detail_pic03' },
          { title: '关于包拯', imgUrl: 'service_detail_pic04' }
        ],
        io : ''
      }
    },
    watch: {},
    computed: {},
    created () {
      
    
    },
    mounted () {
      this.displayShow();
    },
    methods: {
      displayShow(){
        this.io = new IntersectionObserver((entrys) => {
          entrys.forEach((element) => {
            console.log(element)
            if(element.isIntersecting){
              this.io.unobserve(element.target);
              //执行诸葛
              zhugeObj.track({
                title : '查看服务详情',
                content : {
                  '服务介绍' : '曝光',
                }
              })
            }
            // this.io.unobserve(element.target);
          })
        })
        setTimeout(()=>{
          this.io.observe(this.$refs.morer);
        },1000)
        // console.log(this.$refs.define)
        

      },
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
    }

  }
</script>

<style lang="scss" scoped>
.blockContent{
  font-size:25px!important;
  word-wrap : break-word ;
}
.serviceIntroduction{
  padding-top: 48px;
  .contentItem{
    padding: 0 40px 40px;
    line-height: 40px;
    h3{
      margin-bottom: 40px;
      line-height: 40px;
      position: relative;
      &::after{
        content: '';
        width: 8px;
        height: 24px;
        background: $primary-color;
        position: absolute;
        left: -12px;
        top:6px
      }
    }
  }
  .van-collapse-item{
    img{
      width: 100%;
    }
  }
  .van-hairline--top::after{
    /*border-top-width:0;*/
    border-color: $border-color;
  }
  .van-hairline--top-bottom::after,
  .van-hairline--top-bottom::after{
    border-width: 0;
  }
  .pdb{
    padding-bottom: 240px;
  }
}
</style>
<style lang="scss">
  .serviceIntroduction{
    .van-collapse-item__title--expanded::after {
      visibility: hidden;
    }
    .van-collapse-item__content{
      padding: 40px;
    }
  }
</style>
<style scoped>
  .serviceIntroduction .contentItem >>> img{
    width: 100%;
  }
</style>
